import Vue from 'vue'
import Router from 'vue-router'
import moduleRouter from './fileLoad'
import routerData from './mould'

import vueResource from 'vue-resource'

Vue.use(Router)
Vue.use(vueResource)

export default new Router({
  base: '/',
  mode: 'history',
  routes: [{
    path: '/',
    name: routerData.index.name,
    component: moduleRouter.index
  }, {
    path: routerData.index.path,
    redirect: '/'
  }, {
    path: routerData.notFind.path,
    name: routerData.notFind.name,
    component: moduleRouter.notFind
  }, {
    path: routerData.news.path,
    name: routerData.news.name,
    component: moduleRouter.news
  }, {
    path: routerData.literature.path,
    name: routerData.literature.name,
    component: moduleRouter.literature
  }, {
    path: routerData.literaturecontent.path,
    name: routerData.literaturecontent.name,
    component: moduleRouter.literaturecontent
  }, {
    path: routerData.training.path,
    name: routerData.training.name,
    component: moduleRouter.training
  }, {
    path: routerData.traininglist.path,
    name: routerData.traininglist.name,
    component: moduleRouter.traininglist,
    props: true
  }, {
    path: routerData.trainingcontent.path,
    name: routerData.trainingcontent.name,
    component: moduleRouter.trainingcontent
  }, {
    path: routerData.services.path,
    name: routerData.services.name,
    component: moduleRouter.services
  }, {
    path: routerData.Partners.path,
    name: routerData.Partners.name,
    component: moduleRouter.Partners
  }, {
    path: routerData.about.path,
    name: routerData.about.name,
    component: moduleRouter.about
  }, {
    path: routerData.database.path,
    name: routerData.database.name,
    component: moduleRouter.database
  }, {
    path: routerData.order.path,
    name: routerData.order.name,
    component: moduleRouter.order
  }, {
    path: routerData.contrast.path,
    name: routerData.contrast.name,
    component: moduleRouter.contrast
  }, {
    path: routerData.urliterature.path,
    name: routerData.urliterature.name,
    component: moduleRouter.urliterature
  }, {
    path: routerData.userinfo.path,
    name: routerData.userinfo.name,
    component: moduleRouter.userinfo
  }, {
    path: routerData.newscontent.path,
    name: routerData.newscontent.name,
    component: moduleRouter.newscontent
  }, {
    path: routerData.serviceslist.path,
    name: routerData.serviceslist.name,
    component: moduleRouter.serviceslist
  }, {
    path: routerData.servicescontent.path,
    name: routerData.servicescontent.name,
    component: moduleRouter.servicescontent
  }, {
    path: routerData.ordercontent.path,
    name: routerData.ordercontent.name,
    component: moduleRouter.ordercontent
  }, {
    path: routerData.record.path,
    name: routerData.record.name,
    component: moduleRouter.record
  }, {
    path: routerData.recordcon.path,
    name: routerData.recordcon.name,
    component: moduleRouter.recordcon
  }]
})



// WEBPACK FOOTER //
// ./src/router/router.js